/**
 * @voltxampere/ui — BMP180 barometric pressure sensor variant (Sprint 48-8)
 *
 * Sprint 48-8 — Older but still common sibling to BMP280. I2C 7-bit
 * slave 0x77 (fixed). Less accurate but cheaper and widely used in
 * Arduino tutorials, weather stations, drone altimeters from ~2014
 * onward. Replaces BMP085 (predecessor, register-compatible).
 *
 * Sensor activation layer reads:
 *   - 0xD0 chip ID → constant 0x55
 *   - 0xAA..0xBF: 22 bytes of factory calibration coefficients
 *   - 0xF6..0xF8: pressure / temperature MSB:LSB:XLSB
 *
 * PLACEHOLDER — full Bosch SDP3 calibration math Sprint 50+.
 *
 * Reference: Bosch BMP180 datasheet (BST-BMP180-DS000-09, 2013).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorBmp180 = {
    id: "bmp180",
    nameTr: "BMP180 (I2C Barometrik, klasik, placeholder)",
    nameEn: "BMP180 (I2C Barometric, classic, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "BMP180",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 3.3,
        i2cAddress: 0x77,
        i2cFrequency: 100_000, // BMP180 standard mode only
        chipIdRegister: 0xd0,
        chipIdValue: 0x55,
        pressureRangeHpa: { min: 300, max: 1100 },
        temperatureRangeC: { min: -40, max: 85 },
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-bmp180.js.map